import { ALT_SERP_AT, PDP_XSELL_TOP } from './names'

import { ExperimentName } from './types'

/**
 * List of experiments that are manually activated.
 *
 * Add experiment name here if experiment is something like aa test
 */
export const MANUALLY_ACTIVATED: ExperimentName[] = [
  // Experiment has no <Experiment name=... /> part,
  // so it must be enabled manually
  ALT_SERP_AT
]

/**
 * Experiments that should be displayed only once
 */
export const FIRST_IMPRESSION: ExperimentName[] = [PDP_XSELL_TOP]
